import client from '../../providers/fetchClient'

export const getInstallments = params => client.get('/v3/installments', { params })
